import $ from 'jquery';
import Header from './Header';
export default class TopMenu {
    static mount() {
        $(function () {
            new TopMenu();
        });
    }
    constructor() {
        this.$topMenu = $('.ce-topmenu');
        this.$intasLogo = $('.ce-icon-menu .intas-logo');
        this.$mobileTarget = $('.ce-icon-menu .wp-block-navigation__responsive-dialog .wp-block-navigation__responsive-container-content > ul');
        this.$dummyLi = $('<li class="additional-content-container"></li>');
        this.$mobileTarget.append(this.$dummyLi);
        this.$dummyLi.append(this.$intasLogo);
        this.$intasLogo.show();
        this.$desktopTarget = this.$topMenu.parent();
        if (this.$topMenu.length === 0 || this.$mobileTarget.length === 0 || this.$desktopTarget.length === 0)
            return;
        $(window).on('resize', () => { this.checkMenuPosition(); });
        this.checkMenuPosition();
        this.$topMenu.show();
        // Automatische Kontrastanpassung
        this.updateContrastColor();
        $(window).on('scroll resize', () => { this.updateContrastColor(); });
        // MutationObserver für dynamische DOM-Änderungen (z.B. Slider-Load)
        this.observeDomChanges();
    }
    checkMenuPosition() {
        if (Header.isMobileVariantHeader()) {
            if (this.$topMenu.parent()[0] != this.$mobileTarget[0]) {
                this.$intasLogo.detach();
                this.$topMenu.detach();
                this.$dummyLi.append(this.$topMenu);
            }
        }
        else {
            if (this.$topMenu.parent()[0] != this.$desktopTarget[0]) {
                this.$topMenu.detach();
                this.$desktopTarget.append(this.$topMenu);
                this.$dummyLi.append(this.$intasLogo);
            }
        }
    }
    /**
     * Berechnet die effektive Hintergrundfarbe durch Übereinanderlegen aller Eltern-Hintergründe
     * und setzt die Textfarbe auf optimal kontrastierenden Wert
     */
    updateContrastColor() {
        const $links = $('header .wpml-ls .wpml-ls-item a');
        if ($links.length === 0)
            return;
        // Verwende das erste Link-Element für die Positionsberechnung
        const linkElement = $links[0];
        const effectiveBackground = this.getEffectiveBackgroundColorAtPosition(linkElement);
        const luminance = this.calculateLuminance(effectiveBackground);
        // Schwellenwert für Kontrast: bei dunklem Hintergrund weiß, bei hellem schwarz
        const textColor = luminance > 0.5 ? '#000000' : '#ffffff';
        // Farbe auf WPML Language Switcher Links anwenden (mit !important)
        $links.each(function () {
            this.style.setProperty('color', textColor, 'important');
        });
    }
    /**
     * Ermittelt die effektive Hintergrundfarbe an der Position des Elements
     * durch Berücksichtigung aller visuell darunterliegenden Elemente
     */
    getEffectiveBackgroundColorAtPosition(element) {
        const rect = element.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;
        // Temporär alle Header-Elemente unsichtbar machen
        const header = document.querySelector('header');
        const originalPointerEvents = header ? header.style.pointerEvents : '';
        if (header) {
            header.style.pointerEvents = 'none';
        }
        let r = 255, g = 255, b = 255; // Start mit Weiß als Basis
        let hasSliderWithImage = false;
        // Finde alle Elemente an dieser Position
        const elementsAtPoint = document.elementsFromPoint(x, y);
        for (const el of elementsAtPoint) {
            // Überspringe Header-Elemente
            if (header && (el === header || header.contains(el)))
                continue;
            // Prüfe auf Slider mit Hintergrundbild (SmartSlider)
            const className = el.className || '';
            const style = window.getComputedStyle(el);
            if (className.includes('n2-ss-slide') || className.includes('n2-ss-slider')) {
                // Prüfe auf background-image oder img-Element
                if (style.backgroundImage && style.backgroundImage !== 'none') {
                    hasSliderWithImage = true;
                }
                // Prüfe auf img-Kindelemente
                if (el.querySelector('img')) {
                    hasSliderWithImage = true;
                }
            }
            const bgColor = style.backgroundColor;
            const rgba = this.parseRgba(bgColor);
            if (rgba) {
                const [cr, cg, cb, alpha] = rgba;
                if (alpha > 0) {
                    // Alpha-Blending
                    r = Math.round(cr * alpha + r * (1 - alpha));
                    g = Math.round(cg * alpha + g * (1 - alpha));
                    b = Math.round(cb * alpha + b * (1 - alpha));
                }
            }
        }
        // Pointer-Events wiederherstellen
        if (header) {
            header.style.pointerEvents = originalPointerEvents;
        }
        // Wenn ein Slider mit Bild gefunden wurde, nehme dunklen Hintergrund an
        if (hasSliderWithImage) {
            return [0, 0, 0]; // Schwarz für Slider-Bilder
        }
        return [r, g, b];
    }
    /**
     * Parst rgba/rgb Farbwerte aus CSS-String
     */
    parseRgba(color) {
        const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
        if (!match)
            return null;
        return [
            parseInt(match[1]),
            parseInt(match[2]),
            parseInt(match[3]),
            match[4] ? parseFloat(match[4]) : 1
        ];
    }
    /**
     * Berechnet relative Luminanz nach WCAG-Standard
     */
    calculateLuminance(rgb) {
        const [r, g, b] = rgb.map(val => {
            const normalized = val / 255;
            return normalized <= 0.03928
                ? normalized / 12.92
                : Math.pow((normalized + 0.055) / 1.055, 2.4);
        });
        return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    }
    /**
     * Überwacht DOM-Änderungen (z.B. Slider-Load) und aktualisiert Farbe
     */
    observeDomChanges() {
        this.mutationObserver = new MutationObserver(() => {
            this.throttledUpdateContrastColor();
        });
        // Überwache Änderungen am gesamten Header-Bereich
        const headerElement = document.querySelector('header');
        if (headerElement) {
            this.mutationObserver.observe(headerElement, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['style', 'class']
            });
        }
    }
    /**
     * Throttled Version der Kontrastaktualisierung (max. alle 100ms)
     */
    throttledUpdateContrastColor() {
        if (this.updateThrottleTimer)
            return;
        this.updateThrottleTimer = window.setTimeout(() => {
            this.updateContrastColor();
            this.updateThrottleTimer = undefined;
        }, 100);
    }
}
